import { useFetchProductsByReleaseIdPublicQuery } from "../../../api/products/hooks/usefetchProductsByReleaseIdPublicQuery";
import { useFetchReleaseQuery } from "../../../api/releases/hooks/useFetchReleaseQuery";
import { DEFAULT_RELEASE_TITLE } from "../../../store/models/release";
import { DollarFormatter } from "../../../store/utils/formatUtils";
import { ProductCardProps } from "../ProductCard/ProductCard";
import { ProductCardsList } from "../ProductCardsList/ProductCardsList";

type ProductProps = Omit<ProductCardProps, "onShowMore">;

interface FeaturedReleaseProductsProps {
  featuredReleaseId?: number;
}

export const FeaturedReleaseProducts = ({
  featuredReleaseId,
}: FeaturedReleaseProductsProps) => {
  const { data: release } = useFetchReleaseQuery(featuredReleaseId);
  const { data, isPending } =
    useFetchProductsByReleaseIdPublicQuery(featuredReleaseId);
  const products = data ? data : [];
  if (!featuredReleaseId) {
    return null;
  }
  if (!release) {
    return null;
  }
  const normalizedProductsData: ProductProps[] = products.reduce<
    ProductProps[]
  >((result, product) => {
    // Transform and add valid products
    result.push({
      coverPhoto: product.cover_photo || release.release_cover,
      name:
        !product.name || product.name === DEFAULT_RELEASE_TITLE
          ? release.title
          : product.name,
      description: product.description || release.description || "",
      totalPrice: DollarFormatter(product.currency).format(
        parseFloat(product.total_price),
      ),
      productId: product.id,
      releaseId: product.release_id,
      productPurchasedByCurrentUser: product.product_purchased_by_current_user,
      availableQuantity: product.available_quantity,
      purchaseLimit: product.purchase_limit,
      publishedAt: product.published_at || null,
      publishedEnd: product.published_end || null,
      releasePublishedAt: release.published_at || null,
      releasePublishedEnd: release.published_end || null,
    });

    return result;
  }, []);

  return (
    <ProductCardsList loading={isPending} products={normalizedProductsData} />
  );
};
